'use strict';

export default function($){
/* 

/api/resource?parentid=[current page node id]&country=[name of country selected, default to Australia Domestic]

*/
 
    $("[get-resources-by-country]").each(function(){
        var $this = $(this),
            $currentCountry = typeof Cookies.get("currentCountry") === "undefined" ? "Australia1" : Cookies.get("currentCountry"),
            $url = "/api/resource?parentid="+$(this).data("nodeid")+"&country=" + Cookies.get("currentCountry"),
            $html = '<div class="col-sm-6 col-xs-12 u-mbb3">' + 
                        '<div class="c-downloads__title">' + 
                            '<span class="g-icon-download u-c-blue"></span>' + 
                            '<a target="_blank" rel="noopener noreferrer" href="[__url]">[__title]</a>' + 
                        '</div>' + 
                        '<div class="c-downloads__file-info u-fsi text-left">([__file], [__size])</div>' + 
                    '</div>';

            $.ajax({
                url: $url,
                dataType: "json",
                success: function success(response) {             
                    var $r = response,
                        $output = "";
                    if ($r.length > 0) {
                        for (var $i = 0, $leng = $r.length; $i < $leng; $i++) {
                            var $out = $html
                                        .replace("[__url]",String($r[$i].FileUrl))
                                        .replace("[__title]",String($r[$i].ResourceName))
                                        .replace("[__file]",String($r[$i].FileType))
                                        .replace("[__size]",String($r[$i].FileSize));
                            $output += $out;
                        };
                        $(".resource-list").append($output);
                        $($this).removeClass("hidden");
                        $(".sidebar-menu [brochures-publications]").removeClass("hide");
                    } else {
                        
                    }
                }
            });            
    });

};


// WEBPACK FOOTER //
// ./src/_js/partials/country-resources.js